import { FormGroup } from "@angular/forms";

export interface IFpxShell extends Partial<IShellButtonAction> {
  btnList: IBtn[];
  onBtnClick: (action: keyof IShellButtonAction) => void;
  formGroup : FormGroup;
  doPreInit() : void;
  _setFormGroup(form: FormGroup) : void;
  loadDependencies() : void;
}

export interface IBtn {
  label: string;
  buttonClass: 'btn-primary' | 'btn-secondary' | 'btn-tertiary';
  buttonType: 'submit' | 'button' | 'reset';
  buttonAction: keyof IShellButtonAction;
  disabled? : boolean
}

export interface IShellButtonAction {
  onApprove: () => void;
  onReject: () => void;
  onCancel: () => void;
  onDelegate: () => void;
  onResubmit: () => void;
  onBack: () => void;
  onRevert: () => void;
  onSubmit: () => void;
  onReset: () => void;
}

